import search from '../../../components/search'
import page from "../../../components/page"
import {api,imgPath} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {store} from '../../../store/store.js'
export default {
  name:'libraryMore',
  data(){
    return {
      imgPath:imgPath,
      isLibrary:true,
      DataList:{},//
      pageNo: 1,
      pageCount: 12,
      totalPage: 0,
      totalCount: 0,
      webType:store.webType,
      opacType: store.opacType,
      locationCode:'',
      libCode:'',
      levelFlag:'',
      error: store.imgError_library,
    }
  },
  components:{
    search,
    page
  },
    watch: {
        $route() {
            this.queryData();
        }
    },
  beforeMount() {
    if(store.webType == 0) {
      store.libraryNav.activeNav = '总分馆';
    } else {
      store.wrap.activeRouteName = '总分馆';
    }
    this.queryData();
  },
  methods: {
    paging: function (pageNo) {
      CommonUtil.mergeQuery(this,{page: pageNo})
    },

    queryData(){
          this.locationCode = this.$route.query.latLng || store.localtionArea.latLng;
          this.libCode=this.$route.query.libCode || this.$route.query.hallCode;
          this.levelFlag=this.$route.query.levelFlag;
          this.pageNo=this.$route.query.page || 1;
          this.pageCount=12;
          this.totalPage=0;
          this.totalCount=0;
          var url= this.levelFlag == 1?api.library.getOneLevelLibrary:api.library.getTwoLevelLibrary;
          url=url.replace('{libCode}',this.libCode).replace('{lngLat}',this.locationCode).replace('{pageNo}',this.pageNo).replace('{pageCount}',this.pageCount);
           ajaxUtil.ajaxJson(url, null, "GET",  (data)=> {
              this.DataList=data.resultList;
              this.totalPage=data.totalPage;
              this.totalCount=data.totalCount;
          }, null, this);
      },


    toLibraryInfo(libId, libCode, libName, libLevel, logo,websiteUrl)
    {
      if(websiteUrl!=null && websiteUrl.trim()!=""){
        window.open(websiteUrl);
        return;
      }
      var latLng = this.$route.query.latLng || store.localtionArea.latLng;
      var locationCode = this.$route.query.code || "510107";
      store.library.id = libId;
      store.library.libraryLevel = libLevel;
      store.library.name = libName;
      if(store.webType == 1) {
            CommonUtil.mergeQuery(this, {hallCode: libCode});
      }
      var url=store.webType==1 ? '/webintroduce':'/introduce';
        this.$router.push({
            path: url, query: {
                fromSearch: this.$route.query.fromSearch,
                libCode: libCode,
                libId: libId,
                //libName: libName,
                libName: libName,
                libLevel: libLevel,
                latLng: latLng,
                locationCode: locationCode,
                // logo: logo,
            }
        });
    }
  }
}
